import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { stringUtil } from "../../utilities/string";

export function useCreateAppointmentNotificationMutation(options = {}) {
  return useMutation((dto) => {
    return http.post(
      HTTP_ENDPOINTS.appointments.sendAppointmentNotification(
        dto.appointmentId,
      ),
      {
        appointment_id: dto.appointmentId,
        action: dto.action,
        notification_type: dto.notificationType,
        notification_body: stringUtil.toBase64(dto.notificationBody),
        notification_subject: dto.subject,
        sms_body: stringUtil.toBase64(dto.sms),
      },
    );
  }, options);
}
